import Page from "../Common/Page";
import React from "react";
import { Table, Form, Button, Row, Col, Select } from "antd";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { Link } from "react-router-dom";
import { getSubjectOptions, getTeacherOptions } from "../Common/Utils";
import moment from "moment";
import { AbsenceTag } from "../Common/Icons";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";

const { Option } = Select;

export class ProgressPage extends React.Component<any, any> {
  static contextType = AuthContext;

  private _page: React.RefObject<Page>;
  constructor(props: any, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this.state = {
      defaultFy: context.user.currentYear.toString(),
      subjectOptions: [],
      teacherOptions: [],
      detailTeacherName: "",
      datas: [],
      detailDatas: [],
      subject: "",
    };
  }
  async componentDidMount() {
    const teacherOptions = await getTeacherOptions(this.context.accessToken);
    this.setState({
      teacherOptions: teacherOptions,
    });
  }
  // onChange = (pagination: any, filters: any, sorter: any, extra: any) => {
  //   console.log("params", pagination, filters, sorter, extra);
  // };
  columns = [
    {
      title: <div className="table-title">教員名</div>,
      key: "name",
      width: "30%",
      render: (value: any, item: any, index: number) =>
        `${item.sei} ${item.mei}`,
    },
    {
      title: <div className="table-title">割当数</div>,
      dataIndex: "countOfAllocation",
      key: "countOfAllocation",
      width: "15%",
    },
    {
      title: <div className="table-title">採点済</div>,
      dataIndex: "countOfCommited",
      key: "countOfCommited",
      width: "15%",
    },
    {
      title: <div className="table-title">採点進捗ステータス</div>,
      key: "status",
      width: "30%",
      render: (value: any, item: any, index: number) => {
        if (item.status === 1) {
          return "未採点";
        } else if (item.status === 2) {
          return "採点中";
        } else if (item.status === 3) {
          return "全担当分提出済";
        }
      },
    },
    {
      title: "",
      key: "action",
      width: "10%",
      render: (value: any, item: any, index: number) => {
        return (
          <Link
            onClick={() => {
              this.onDetailLinkClick(
                item.applicantList,
                `${item.sei} ${item.mei}`
              );
            }}
            to={""}
          >
            詳細
          </Link>
        );
      },
    },
  ];
  detailColumns = [
    {
      title: <div className="table-title">No</div>,
      key: "no",
      width: "5%",
      render: (value: any, item: any, index: number) => (
        <span>{index + 1}</span>
      ),
    },
    {
      title: <div className="table-title">受験番号</div>,
      dataIndex: "examNo",
      key: "examNo",
    },
    {
      title: <div className="table-title">氏名</div>,
      key: "name",
      render: (value: any, item: any, index: number) =>
        `${item.ssei} ${item.smei}`,
    },
    {
      title: <div className="table-title">カナ</div>,
      key: "kana",
      render: (value: any, item: any, index: number) =>
        `${item.sseiKana} ${item.smeiKana}`,
    },
    {
      title: <div className="table-title">合計点</div>,
      // dataIndex: "totalScore",
      key: "totalScore",
      className: "score-column",
      render: (value: any, item: any, index: number) => {
        if (item.absenceFlag === "1") {
          return AbsenceTag;
        } else {
          return item.totalScore;
        }
      },
    },
    {
      title: <div className="table-title">採点ステータス</div>,
      key: "status",
      render: (value: any, item: any, index: number) => {
        //0：未採点、1：採点中、2：採点完了、3：提出済、4：確定
        if (item.resultConfirmId != null) {
          return "確定";
        } else {
          if (item.scoringStatus === null || item.scoringStatus === "0") {
            return "未採点";
          } else if (item.scoringStatus === "1") {
            return "採点中";
          } else if (item.scoringStatus === "2") {
            return "採点完了";
          } else if (item.scoringStatus === "3") {
            return "提出済";
          } else if (item.scoringStatus === "4") {
            return "確定";
          }
        }
      },
    },
  ];

  // getTeacherOptions = async (): Promise<SelectOptionData[]> => {
  //   var path = `/Master/teachers`;
  //   const result = await http<SelectOptionData[]>({
  //     path: path,
  //     accessToken: this.context.accessToken,
  //   });
  //   if (result.ok && result.body) {
  //     return result.body;
  //   } else {
  //     return [];
  //   }
  // };

  // getSubjectOptions = async (jid: string): Promise<SelectOptionData[]> => {
  //   var path = `/Master/subjects`;
  //   path = path + `?jid=${jid}`;
  //   const result = await http<SelectOptionData[]>({
  //     path: path,
  //     accessToken: this.context.accessToken,
  //   });
  //   if (result.ok && result.body) {
  //     return result.body;
  //   } else {
  //     return [];
  //   }
  // };

  onFinish = async (values: any) => {
    // console.log("search:", values);
    try {
      this._page.current?.setState({ isPageLoading: true });
      this.setState({
        detailTeacherName: "",
        detailDatas: [],
      });
      const searchData = {
        Fy: this.state.defaultFy,
        JudgementUnitId: values.judgmentUnit ? values.judgmentUnit : null,
        ExaminationSubjectId: values.subject ? values.subject : null,
        UserId: values.teacher ? values.teacher : null,
        Status: values.scoreStatus ? values.scoreStatus : null,
      };
      const result = await http<any[], any>({
        path: "/ScoreAllocation/search",
        method: "post",
        body: searchData,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          datas: result.body,
        });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (
      record &&
      record.fyJudgementUnitId &&
      record.fyJudgementUnitId.length > 0
    ) {
      const subjectOptions = await getSubjectOptions(
        this.context.accessToken,
        record.fyJudgementUnitId,
        undefined,
        undefined,
        undefined
      );
      this.setState({
        subjectOptions: subjectOptions,
        subject: "",
        detailTeacherName: "",
        datas: [],
        detailDatas: [],
      });
    } else {
      this.setState({
        subjectOptions: [],
        subject: "",
        detailTeacherName: "",
        datas: [],
        detailDatas: [],
      });
    }
  };

  onDetailLinkClick = (details: [], teacherName: string) => {
    this.setState({
      detailDatas: details,
      detailTeacherName: teacherName,
    });
  };
  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
    });
  };
  onSubjectChanged = (newValue) => {
    this.setState({
      subject: newValue,
      detailTeacherName: "",
      datas: [],
      detailDatas: [],
    });
  };
  render(): React.ReactNode {
    return (
      <Page ref={this._page} title="教員別採点進捗一覧">
        <div className="data_content">
          <Form
            colon={false}
            layout="horizontal"
            labelAlign="left"
            labelWrap={true}
            className="search_form"
            name="searchForm"
            onFinish={this.onFinish}
            initialValues={{
              fy: { value: this.state.defaultFy },
            }}
            fields={[{ name: "subject", value: this.state.subject }]}
          >
            <Row>
              <Col span={6}>
                <Form.Item
                  label="入試年度"
                  labelCol={{ span: 6 }}
                  name="fy"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    allowClear={false}
                    masterType={31}
                    onChange={this.onFyChange}
                  />
                </Form.Item>
              </Col>
              <Col span={15}>
                <Form.Item
                  labelCol={{ span: 3 }}
                  label="判定単位"
                  name="judgmentUnit"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <JudgmentUnitSelecter
                    width={500}
                    defaultFy={this.state.defaultFy}
                    onDataSelect={this.onJudgmentUnitSelected}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item
                  labelCol={{ span: 6 }}
                  label="科目"
                  name="subject"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    allowClear={false}
                    onChange={this.onSubjectChanged}
                    style={{ width: 160 }}
                  >
                    {this.state.subjectOptions.length > 0 &&
                      this.state.subjectOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={7}>
                <Form.Item label="採点ステータス" name="scoreStatus">
                  <Select allowClear={true} style={{ width: 160 }}>
                    <Option key="1" value="1">
                      未採点
                    </Option>
                    <Option key="2" value="2">
                      採点中
                    </Option>
                    <Option key="3" value="3">
                      全担当分提出済
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item labelCol={{ span: 4 }} label="教員" name="teacher">
                  <Select allowClear={true} style={{ width: 160 }}>
                    {this.state.teacherOptions.length > 0 &&
                      this.state.teacherOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={5}>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    表示
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Row>
            <Col span={9}>
              <h2
                style={{
                  display:
                    this.state.datas && this.state.datas.length > 0
                      ? ""
                      : "none",
                }}
              >
                採点期限：
                {this.state.datas && this.state.datas.length > 0
                  ? moment(this.state.datas[0].scoringEndDateTime).format(
                      "yyyy/MM/DD HH:mm"
                    )
                  : ""}
              </h2>
              <Table
                rowKey={(record: any) => record.userId}
                bordered
                pagination={false}
                showSorterTooltip={false}
                columns={this.columns}
                dataSource={this.state.datas}
                scroll={{ y: "calc(100vh - 350px)" }}
                rowClassName={(record, index) => {
                  // const endDate = new Date(record.scoringEndDateTime);
                  // const now = new Date();
                  if (
                    record.isExpired === "1" &&
                    (record.status === 1 || record.status === 2)
                  ) {
                    return "background_color_red";
                  } else {
                    return "";
                  }
                }}
              />
            </Col>
            <Col span={1}></Col>
            <Col span={14}>
              {this.state.detailTeacherName.length > 0 ? (
                <div>
                  <h2>教員：{this.state.detailTeacherName}</h2>
                  <Table
                    rowKey={(record: any) => record.examNo}
                    bordered
                    pagination={false}
                    showSorterTooltip={false}
                    columns={this.detailColumns}
                    dataSource={this.state.detailDatas}
                    scroll={{ y: "calc(100vh - 350px)" }}
                  />
                </div>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </div>
      </Page>
    );
  }
}
